import React from 'react'
import { FormikProps, useFormikContext } from 'formik'
import { BoxV4, PlanType } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'

import { AdditionalUsageDimensionsV2 } from '../../../../common/components/AdditionalUsageDimensionsV2/AdditionalUsageDimensionsV2'
import { ResaleAuthorizationWithErrors } from '../../../../modules/resaleAuthorization/types'
import type { ResaleUsageDimensionsProps } from '../../types'

export type { ResaleUsageDimensionsProps }
export const ResaleUsageDimensions: React.FC<ResaleUsageDimensionsProps> = ({
  product,
}) => {
  const formikProps =
    useFormikContext() as FormikProps<ResaleAuthorizationWithErrors>

  return (
    <div data-testid="usage-Dimensions-section">
      <BoxV4
        heading={'Usage dimensions'}
        headingIcon={
          <FontAwesomeIcon
            icon={faShelves}
            style={{ width: '18px', height: '14px' }}
          />
        }
      >
        <AdditionalUsageDimensionsV2
          formik={
            formikProps as unknown as FormikProps<Record<string, unknown>>
          }
          dimensionsHeadingName={'Name'}
          inputFieldTitle={'Enter price'}
          heading={
            'Set the unit price for additional usage beyond the contract limit.'
          }
          isResale={true}
          productType={product?.productType}
          shouldShowHeading={
            product?.productType !== PlanType.SAAS_SUBSCRIPTION
          }
        />
      </BoxV4>
    </div>
  )
}
